import classNames from 'classnames';
import { displayDate } from '../../commons/utils/date.util';
import { IMessageProps } from './interfaces';
import './style.scss';

export default function Message({ message }: IMessageProps) {
  const isSentByCustomer = message.sendType === 'CUSTOMER';

  const messageContainerClass = classNames({
    'message-container': true,
    green: !isSentByCustomer,
    right: !isSentByCustomer
  });

  const processMessageContent = (content: string): JSX.Element[] => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = content.split(urlRegex);

    return parts.map((part, index) => {
      const fileName = part.split('/').pop() || 'Archivo';

      if (part.match(/\.(jpg|jpeg|png)$/)) {
        return (
          <img
            key={`img-${index}`}
            src={part}
            alt={fileName}
            title={fileName}
            style={{ maxWidth: '70%', height: 'auto' }}
            onClick={() => downloadImage(part)}
          />
        );
      } else if (part.match(/\.pdf$/)) {
        return (
          <a
            key={`pdf-${index}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            title={fileName}>
            <img
              src="https://thumbs.dreamstime.com/b/icono-del-vector-de-descarga-archivo-pdf-documento-descargar-en-fondo-blanco-193233210.jpg"
              alt="PDF"
              style={{ width: '100px', cursor: 'pointer' }}
            />
          </a>
        );
      } else if (part.match(/\.(doc|docx)$/)) {
        return (
          <a
            key={`word-${index}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            title={fileName}>
            <img
              src="https://images.sftcdn.net/images/t_app-icon-m/p/b20c5e90-96bf-11e6-9781-00163ed833e7/4112465458/microsoft-word-microsoft_word_2019_16_icon.jpg"
              alt="Word"
              style={{ width: '100px', cursor: 'pointer' }}
            />
          </a>
        );
      } else if (part.match(/\.(xls|xlsx)$/)) {
        return (
          <a
            key={`excel-${index}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            title={fileName}>
            <img
              src="https://t3.ftcdn.net/jpg/02/47/49/68/360_F_247496813_lxU4bG65TZHW1HSIlKAcfrsNYhPBnUOP.jpg"
              alt="Excel"
              style={{ width: '100px', cursor: 'pointer' }}
            />
          </a>
        );
      } else if (part.match(/https?:\/\/[^\s]+/)) {
        return (
          <a
            key={`link-${index}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            title={fileName}>
            {fileName}
          </a>
        );
      } else {
        return <span key={`text-${index}`}>{part}</span>;
      }
    });
  };

  const downloadImage = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.split('/').pop() || 'image.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={messageContainerClass}>
      <div className="message">
        <div className="message-content">{processMessageContent(message.message)}</div>
        <small>{displayDate(message.creationDate, 'hh:mm')}</small>
      </div>
    </div>
  );
}
